export type Permission = {
	accountId: string;
	departmentId: string;
	permissionExpiration?: string;
};

export type UserProfile = {
	response: any;
	userId: string;
	upId: string;
	userName: string;
	userType: string;
	accountName: string;
	email: string;
	objectId: string;
	accountPermissions: Permission[];
	departmentPermissions: Permission[];
	contactNumber1: string;
};

const model = {
	response: 'response',
	userId: 'response.getCurrentUserDetailsResponse.userData.userId',
	upId: 'response.getCurrentUserDetailsResponse.userData.upId',
	userName: 'response.getCurrentUserDetailsResponse.userData.userName',
	userType: 'response.getCurrentUserDetailsResponse.userData.userType',
	accountName: 'response.getCurrentUserDetailsResponse.userData.accountName',
	email: 'response.getCurrentUserDetailsResponse.userData.email',
	objectId: 'response.getCurrentUserDetailsResponse.userData.objectId',
	departmentPermissions: ['response.getCurrentUserDetailsResponse.departmentPermissions', []],
	accountPermissions: ['response.getCurrentUserDetailsResponse.accountPermissions', []],
	contactNumber1: ['response.getCurrentUserDetailsResponse.userData.contactNumber1', []],
};

export default model;
